import isString from 'strings/isString'

export default (value) => isString(value) && value.replace(/(\s+)(or)(\s+)/gi, '$1|$3')
